module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "users"
  }, [_c('el-form', {
    ref: "userData",
    staticClass: "new-user-form",
    attrs: {
      "model": _vm.userData,
      "rules": _vm.validators,
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Role",
      "prop": "role"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "User role"
    },
    model: {
      value: (_vm.userData.role),
      callback: function($$v) {
        _vm.$set(_vm.userData, "role", $$v)
      },
      expression: "userData.role"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "General",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Booking",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Admin",
      "value": "2"
    }
  }), _vm._v(" "), (_vm.userIsSuperAdmin) ? _c('el-option', {
    attrs: {
      "label": "Super Admin",
      "value": "3"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.userIsSuperAdmin) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Client",
      "prop": "client_id"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Client"
    },
    model: {
      value: (_vm.userData.client_id),
      callback: function($$v) {
        _vm.$set(_vm.userData, "client_id", $$v)
      },
      expression: "userData.client_id"
    }
  }, _vm._l((_vm.clients), function(client) {
    return _c('div', {
      key: client.id
    }, [_c('el-option', {
      attrs: {
        "label": client.name,
        "value": String(client.id)
      }
    })], 1)
  }))], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.userData.name),
      callback: function($$v) {
        _vm.$set(_vm.userData, "name", $$v)
      },
      expression: "userData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Username",
      "prop": "username"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.userData.username),
      callback: function($$v) {
        _vm.$set(_vm.userData, "username", $$v)
      },
      expression: "userData.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.userData.email),
      callback: function($$v) {
        _vm.$set(_vm.userData, "email", $$v)
      },
      expression: "userData.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Send an email?"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": ""
    },
    model: {
      value: (_vm.sendAnEmail),
      callback: function($$v) {
        _vm.sendAnEmail = $$v
      },
      expression: "sendAnEmail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Generate password?"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": ""
    },
    model: {
      value: (_vm.generatePass),
      callback: function($$v) {
        _vm.generatePass = $$v
      },
      expression: "generatePass"
    }
  })], 1), _vm._v(" "), (_vm.generatePass) ? _c('div') : _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Set password",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.userData.password),
      callback: function($$v) {
        _vm.$set(_vm.userData, "password", $$v)
      },
      expression: "userData.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Confirm password",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.userData.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.userData, "checkPass", $$v)
      },
      expression: "userData.checkPass"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "save"
    },
    on: {
      "click": function($event) {
        _vm.submit('userData')
      }
    }
  }, [_vm._v("Create")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "cancel"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71f24e92","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Users/NewUser.vue
// module id = 1138
// module chunks = 0